export default "__VITE_ASSET__BdywnQdk__"